module.exports = __webpack_public_path__ + "static/media/greater-than.a3be2d4f.svg";